import CommonStore from './commonStore';
import LoginStore from '@/feature/login/stores/LoginStore';
import MainStore from '@/feature/main/stores/MainStore';
import JoinStore from '@/feature/join/stores/JoinStore';
import FundingStore from '@/feature/funding/stores/FundingStore';
import MyPageStore from '@/feature/mypage/stores/MyPageStore';

export const rootStore = {
  commonStore: CommonStore,
  loginStore: LoginStore,
  mainStore: MainStore,
  joinStore: JoinStore,
  fundingStore: FundingStore,
  myPageStore: MyPageStore
};
